module.exports = __webpack_public_path__ + "img/dynamic-lab.1e50c92b.png";